import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FamilyCalendar from './FamilyCalendar';

const FamilySpace = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('calendar');

  return (
    <div className="max-w-[1200px] mx-auto py-20 px-5 min-h-screen max-md:py-[70px] max-md:px-4 max-md:pb-8">
      <header className="text-center mb-8">
        <h1 className="text-[40px] max-md:text-[28px] font-bold text-[#1d1d1f] m-0 mb-3 tracking-[-0.02em]">
          {t('family.title')}
        </h1>
        <p className="text-[#86868b] text-lg max-md:text-[15px] m-0">
          {t('family.subtitle')}
        </p>
      </header>

      {/* 탭 네비게이션 */}
      <div className="flex justify-center gap-3 mb-8 max-md:flex-col max-md:items-stretch">
        <button
          className={`flex items-center justify-center gap-2 py-3 px-6 border-none rounded-[980px] text-[15px] font-medium cursor-pointer transition-all duration-200 ${
            activeTab === 'calendar'
              ? 'bg-[#3B82F6] text-white'
              : 'bg-[#f5f5f7] text-[#1d1d1f] hover:bg-[#e5e5e7]'
          }`}
          onClick={() => setActiveTab('calendar')}
        >
          <span className="text-lg">📅</span>
          {t('family.calendar.title')}
        </button>
        <button
          className={`flex items-center justify-center gap-2 py-3 px-6 border-none rounded-[980px] text-[15px] font-medium cursor-pointer transition-all duration-200 ${
            activeTab === 'gallery'
              ? 'bg-[#3B82F6] text-white'
              : 'bg-[#f5f5f7] text-[#1d1d1f] hover:bg-[#e5e5e7]'
          }`}
          onClick={() => setActiveTab('gallery')}
        >
          <span className="text-lg">🖼️</span>
          {t('family.gallery.title')}
        </button>
      </div>

      {/* 탭 컨텐츠 */}
      <div className="bg-transparent">
        {activeTab === 'calendar' && <FamilyCalendar />}

        {activeTab === 'gallery' && (
          <div className="bg-white rounded-[20px] py-20 px-10 max-md:py-12 max-md:px-6 text-center shadow-[0_2px_12px_rgba(0,0,0,0.08)]">
            <div className="text-[64px] max-md:text-[48px] mb-6 opacity-50">🖼️</div>
            <h2 className="text-[28px] max-md:text-[22px] font-semibold text-[#1d1d1f] m-0 mb-3">
              {t('family.gallery.title')}
            </h2>
            <p className="text-base text-[#86868b] m-0 mb-6 max-w-[400px] mx-auto">
              {t('family.gallery.description')}
            </p>
            <span className="inline-block py-2 px-5 bg-gradient-to-br from-[#3B82F6] to-[#8B5CF6] text-white rounded-[980px] text-sm font-semibold">
              Coming Soon
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FamilySpace;
